import request from "@/request";
/**
 * 获取学科门类
 * @returns {AxiosPromise}
 */
export function get_sub(type) {
  return request({
    url: "/api/v1/category/get_sub",
    method: "GET",
    params: { type: type },
  });
}
